import React, { useState } from 'react';
import { Button } from 'primereact/button';
import { toast } from 'react-toastify';
import { exportToExcel } from '../../utilities/exportToExcel';
import usePreferredLanguage from '../../utilities/usePreferredLanguage';
import { translateUiText } from '../../utilities/siteTranslations';

export default function ReportExportButton({ rows, getRows, columns, filename, disabled = false }) {
    const language = usePreferredLanguage();
    const t = (value) => translateUiText(value, language);
    const [exporting, setExporting] = useState(false);
    const download = async () => {
        if (exporting) return;
        setExporting(true);
        try {
            const selectedRows = getRows ? await getRows() : rows;
            if (!selectedRows?.length) {
                toast.info(t('There is no data to export for this section.'));
                return;
            }
            exportToExcel(selectedRows, filename, columns);
        } catch {
            toast.error(t('Failed to export data. Please try again.'));
        } finally {
            setExporting(false);
        }
    };
    return <Button type="button" label={t('Export to Excel')} icon="pi pi-file-excel"
        className="p-button-success p-button-sm" onClick={download} loading={exporting}
        disabled={disabled || exporting} />;
}
